import { i18nReducer } from "react-redux-i18n";
import { applyMiddleware, combineReducers, compose, createStore } from "redux";
import { thunk } from "redux-thunk";

import authReducer from "./reducers/auth";
import BilletReducer from "./reducers/billet";
import blockListReducer from "./reducers/block-list";
import clientReducer from "./reducers/client";
import complaintReducer from "./reducers/complaint";
import contractReducer from "./reducers/contract";
import distributorReducer from "./reducers/distributor";
import enumReducer from "./reducers/enum";
import installmentReducer from "./reducers/installment";
import loadingReducer from "./reducers/loading";
import logReducer from "./reducers/log";
import preContractReducer from "./reducers/pre-contract";
import PaymentReducer from "./reducers/payment";
import ReceivablesAnticipationReducer from "./reducers/receivablesAnticipation";
import reportReducer from "./reducers/report";
import userReducer from "./reducers/user";

export default () => {
  const store = createStore(
    combineReducers({
      i18n: i18nReducer,
      auth: authReducer,
      loading: loadingReducer,
      user: userReducer,
      client: clientReducer,
      complaint: complaintReducer,
      contract: contractReducer,
      billet: BilletReducer,
      payment: PaymentReducer,
      receivablesAnticipation: ReceivablesAnticipationReducer,
      installment: installmentReducer,
      preContract: preContractReducer,
      log: logReducer,
      blockList: blockListReducer,
      distributor: distributorReducer,
      report: reportReducer,
      enum: enumReducer,
    }),
    compose(
      applyMiddleware(thunk),
      window.__REDUX_DEVTOOLS_EXTENSION__
        ? window.__REDUX_DEVTOOLS_EXTENSION__()
        : f => f
    )
  );

  return store;
};
